// Module
var code = "<div class=\"tag-editor\"> <vue-slim-select :options=\"options\" :selected-items=\"selectedItems\" :multiple=\"true\" :show-search=\"true\" :disabled=\"disabled\" :close-on-select=\"true\" ref=\"vueSlimSelect\" @item-added=\"tagAdded\" @item-removed=\"tagRemoved\"> </vue-slim-select> </div>";
// Exports
module.exports = code;